import React, { useState, useEffect } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from 'react-simple-typewriter';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from "react-redux";
import { 
  currentEducation, 
  dispatchEducation, 
  currentEducation_loading
 } from "../../../Redux/ActionCreator";
import { saveIntoServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { ToastContainer, toast } from 'react-toastify';
import { SortEducation } from '../../../utils/skillsService';

const Education3 = ({ nextStep, prevStep, studying, setStep }) => {
  const [endDate, setEndDate] = useState(dayjs());
  const [textLabel, setTextLabel] = useState(false);
  const dispatch = useDispatch();
  const currentEdu = useSelector(state => state.currentEducation);
  console.log("studying", studying);
  const educ = useSelector(edu => edu.education);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const sidebar = useSelector(e => e.sidebarOpen.message);

  // **Function to Convert Formatted String Back to Dayjs**
  const parseFormattedDate = (dateString) => {
    return dateString ? dayjs(dateString, "MMM YYYY") : null;
  };

  // Prefill fields from Redux or fetch from Redis
  useEffect(() => {
    if (currentEdu.message !== null) {
      let current_edu_end_date = parseFormattedDate(currentEdu.message?.End_date);
      setEndDate(current_edu_end_date || null);
    } else {
      getOneFromServerCache("current_education")
        .then(res => res.json())
        .then(res => {
          if (res.success && res.data) {
            const eduData = JSON.parse(res.data);
            let current_edu_end_date = parseFormattedDate(eduData?.End_date);
            setEndDate(current_edu_end_date || null);
            dispatch(currentEducation([]));
          }
        })
        .catch(error => console.log("Error prefilling education data", error));
    }
  }, [dispatch]);

  /* Moving section */
  const handlePrev = () => {
    prevStep();
  }

  const updateEducation = (education, eduToUpdate) => {
    if (!Array.isArray(education) || education.length === 0) {
        console.error("education array is not valid or empty.");
        return;
    }

    if (!eduToUpdate || !eduToUpdate.Course || !eduToUpdate.School) {
        console.error("eduToUpdate is not valid.", eduToUpdate);
        return;
    }

    const eduToUpdateCourse = eduToUpdate.Course;
    const eduToUpdateSchool = eduToUpdate.School;

    console.log("Searching for:", eduToUpdateSchool, eduToUpdateCourse);
    console.log("education array:", education);

    const eduIndex = education.findIndex(e => 
        e.School?.toLowerCase() === eduToUpdateSchool?.toLowerCase() &&
        e.Course?.toLowerCase() === eduToUpdateCourse?.toLowerCase()
    );

    return eduIndex;
};

  const handleNextCall = async () => {
    // handleNext(dispatch, firstName, lastName, nextStep);
    dispatch(currentEducation_loading());
    try {
      if (endDate !== "" && endDate !== null) {
        let educationData = { ...currentEdu.message, End_date: currentEdu.message?.Degree == "No Formal Education" ? null :  endDate.format("MMM YYYY"),
        }
        dispatch(currentEducation(educationData));
        let allEdu = educ.education !== null && educ.education?.length !== 0 ? educ.education : [];
        // let allEdu = []
        // let eduIndex = updateEducation(educ.education, educationData);

        // if (allEdu.length == 0 || eduIndex == -1) {
        //   allEdu.push(educationData);
        //   dispatch(SortEducation(allEdu));          
        //   saveIntoServerCache("education", allEdu);
        // } else {
        //   allEdu[eduIndex] = educationData;
        //   dispatch(SortEducation(allEdu));          
        //   saveIntoServerCache("education", allEdu);
        // }

        if (allEdu?.length == 0) {
          allEdu.push(educationData);
          dispatch(SortEducation(allEdu));          
          saveIntoServerCache("education", allEdu);
        } else {
          allEdu = [...allEdu, educationData];
          dispatch(SortEducation(allEdu));
          saveIntoServerCache("education", allEdu);
        }
        // save into server cache
        await saveIntoServerCache("current_education", []);
        setStep(22);
      } else {
        setTimeout(() => {
          toast.error("Date is required", {
            position: toast.POSITION.TOP_RIGHT,
          });
      }, 50);
      }
    } catch (error) {
        throw error
    }
  }

  const [showEndDate, setShowEndDate] = useState(false);
  const [showButtomBTN, setShowButtomBTN] = useState(false);


  useEffect(() => {
    if (endDate !== null) {
      // Show first name label and input after delay (simulating onDone)
      const showButtomBTNTimeout = setTimeout(() => setShowButtomBTN(true), 500); // Matches Typewriter speed

      return () => clearTimeout(showButtomBTNTimeout);
    }
  }, [endDate]);


  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-0 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="3" current={false} label="Skills" completed={true} />
            </div>
            <Tab num="4" current={false} label="Language" completed={true} />
            <Tab num="4" current={true} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>

        <div className="flex item-center justify-center mb-6 mt-6 w-full">
          <div>
            <p className="text-lg font-semibold mb-2 notranslate">{studying ? (
              <>{flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["¿Cuándo esperas graduarte? (Mes y año)"]} loop={1} typeSpeed={40} />
              ) : (
                 <Typewriter key={flowLanguage} words={["When do you expect to graduate? (Month & Year) "]} loop={1} typeSpeed={40} />
              )}</>): (
              <>
                {flowLanguage == "Spanish" ? (
                  <Typewriter key={flowLanguage} words={["¿Cuándo terminaste tus estudios?"]} loop={1} typeSpeed={40} />
                ) : (
                  <Typewriter key={flowLanguage} words={["When did you complete your studies?"]} loop={1} typeSpeed={40} />
                )}
              </>)}
            </p>
              
            <motion.div 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
              className="flex w-full flex-col gap-y-2 vsm:my-6 md:my-0"
            >
              {/* <label className="text-black font-medium text-sm mb-2">
                {studying == true ? <Typewriter words={["When do you expect to graduate? (Month & Year)?"]} loop={1} typeSpeed={50} /> : <Typewriter words={["When did you finish your studies? (Month & Year)?"]} loop={1} typeSpeed={50} />}
              </label> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    views={['month', 'year']}
                    value={endDate}
                    onChange={(newValue) => setEndDate(newValue)}
                    className="w-full max-w-[400px]"
                  />
                </DemoContainer>
              </LocalizationProvider>
            </motion.div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          {showButtomBTN && (
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                animate={{ opacity: 1, y: 0 }} 
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
                className="flex justify-between lg:max-w-[90%] w-full">
                  <button
                      onClick={handlePrev}
                      className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 px-8 rounded-md"
                  >
                      <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                          "ANTERIOR"
                        ) : (
                          "PREVIOUS"
                        )}
                      </span>
                  </button>
                  
                  <button
                      onClick={handleNextCall}
                      className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 px-6 rounded-md"
                  >
                    <span className="notranslate" key={flowLanguage}>
                      {flowLanguage == "Spanish" ? (
                        "GUARDAR"
                      ) : (
                        "SAVE"
                      )}
                    </span>
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>

              </motion.div>
            )}
          </div>

      </div>
      <ToastContainer />
    </div>
  );
};

export default Education3;
